module.exports = __webpack_public_path__ + "static/media/answerPIC14.1030222d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPIC14.png
// module id = 1721
// module chunks = 0 1